module.exports = __webpack_public_path__ + "static/media/star-full-1.e08feba2.svg";